<template>
  <div
    class="app-button-continue"
    :class="{'invert' : invertStyle}"
    @keydown.enter="$emit('click')"
    v-on="$listeners"
    tabindex="0"
  >
    <slot/>
  </div>
</template>

<script>
/**
 * <app-button-continue></app-button-continue>
 * @desc continue button for each step
 */
export default {
  // Name
  name: 'app-button-continue',

  props: {
    invertStyle: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.app-button-continue {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  width: 100%;
  border: none;
  padding: 11px 0;
  background: $theme-gradient-blue-2;
  border-radius: 6px;
  color: #fff;
  font-size: 19px;
  line-height: 1.5;
  font-weight: 600;
  box-shadow: 8px 8px 25px rgba(0, 0, 0, 0.16);

  &.invert {
    background: white;
    color: $theme-text-blue;
  }

  &:hover {
    transform: translateY(-1px);
    transition: all .15s ease;
  }

  &:focus:not(.focus-visible) {
    outline: none;
  }

  &:focus-visible {
    border: 2px solid blue;
  }

  @include breakpoint('tablet-portrait-up') {
    padding: 20px 0;
    font-size: 24px;
  }

  @include breakpoint('tablet-landscape-up') {
    padding: 16px 0;
    width: 380px;
    font-size: 19px;
  }

  @include breakpoint('desktop-up') {
    width: 380px;
  }
}
</style>
